import React from 'react';
import { Box, H3, Icon, Text } from '@opendoor/bricks/core';

import { DigitalCheckoutForm } from 'sellDirect/components/closingDash/closing/DigitalCheckoutForm';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { ClosedOffer, UnderContractOffer } from 'sellDirect/OfferContext';

export interface DigitalCheckoutProps {
  offer: UnderContractOffer | ClosedOffer;
  closingTasks: ClosingTasks;
}

/**
 * Digital checkout module. Shows form if not completed, confirmation otherwise.
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const DigitalCheckout: React.FC<DigitalCheckoutProps> = ({ offer, closingTasks }) => {
  const hasCompletedDigitalCheckout = !!offer?.closingExperience.digitalCheckout?.submittedAt;

  return hasCompletedDigitalCheckout ? (
    <Box padding="24">
      <Icon name="expertise" size={32} color="brand50" />
      <H3 fontWeight="bold" mb={5}>
        Congrats! Your digital checkout is complete.
      </H3>
      <Text>
        Next, we’ll review these photos and your Experience Partner will reach out if there’s any
        follow-up needed.
      </Text>
    </Box>
  ) : (
    <DigitalCheckoutForm offer={offer} closingTasks={closingTasks} />
  );
};
